import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserSubType, UserType } from '../interfaces/core/core.entity';

@Injectable({ providedIn: 'root' })
export class CoreService {
	private gatewayURL: string = environment.gatewayURL;

	constructor(private http: HttpClient) {}

	getUserTypes(): Observable<UserType[]> {
		return this.http
			.get<{
				data: UserType[];
			}>(`${this.gatewayURL}/v1/core/user-types`)
			.pipe(map((response) => response.data));
	}

	getUserSubTypes(): Observable<UserSubType[]> {
		return this.http
			.get<{
				data: UserSubType[];
			}>(`${this.gatewayURL}/v1/core/user-sub-types`)
			.pipe(map((response) => response.data));
	}
}
